import { useEffect, useState, type FormEvent } from 'react'
import { Brand } from '../components/Brand'
import { getSupabaseClient, updateStagingPassword } from '../offline/supabase'

export function AuthCallbackScreen() {
  const [ready, setReady] = useState(false)
  const [saving, setSaving] = useState(false)
  const [status, setStatus] = useState('Checking the staging authentication response…')

  useEffect(() => {
    const client = getSupabaseClient()
    if (!client) { setStatus('Staging authentication is not configured.'); return }
    let disposed = false
    void client.auth.getSession().then(({ data }) => {
      if (disposed) return
      if (data.session) { setReady(true); setStatus('Choose a new password for the staging owner account.') }
    })
    const listener = client.auth.onAuthStateChange((event, session) => {
      if (disposed) return
      if (event === 'PASSWORD_RECOVERY' || session) {
        setReady(true)
        setStatus('Choose a new password for the staging owner account.')
      }
    })
    return () => { disposed = true; listener.data.subscription.unsubscribe() }
  }, [])

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const form = event.currentTarget
    const data = new FormData(form)
    const password = String(data.get('password') ?? '')
    const confirmation = String(data.get('confirmation') ?? '')
    if (password.length < 12) { setStatus('Use at least 12 characters.'); return }
    if (password !== confirmation) { setStatus('The two passwords do not match.'); return }
    setSaving(true)
    try {
      const { error } = await updateStagingPassword(password)
      if (error) throw error
      form.reset()
      setReady(false)
      setStatus('Password saved. You can now return to Ops Matrix and sign in.')
    } catch {
      setStatus('The password could not be saved. Request a fresh setup link and try again.')
    } finally {
      setSaving(false)
    }
  }

  return <main className="centred-page"><section className="auth-card panel"><Brand /><h1>Set staging password</h1>{ready ? <form className="staging-signin" onSubmit={(event) => void submit(event)}><label>New password<input name="password" type="password" autoComplete="new-password" minLength={12} required /></label><label>Confirm password<input name="confirmation" type="password" autoComplete="new-password" minLength={12} required /></label><button className="button button-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save password'}</button></form> : <span className="spinner" aria-hidden="true" />}<p role="status" aria-live="polite">{status}</p><a className="button" href="/?screen=settings">Return to Ops Matrix</a></section></main>
}
